module.exports = __webpack_public_path__ + "img/header_dsk@2x.0564b50.jpg";